module.exports = __webpack_public_path__ + "img/gift-icon.4c47b5ac.png";